import { defineComponent as r, ref as a, onMounted as n, openBlock as l, createBlock as d, Teleport as f, renderSlot as u, createCommentVNode as c } from "vue";
const p = /* @__PURE__ */ r({
  name: "RevPortal",
  __name: "Portal",
  props: {
    to: { default: "body" },
    defer: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = a(!1);
    return n(() => {
      t.value = !0;
    }), (o, m) => t.value ? (l(), d(f, {
      key: 0,
      defer: e.defer,
      to: e.to
    }, [
      u(o.$slots, "default")
    ], 8, ["defer", "to"])) : c("", !0);
  }
});
export {
  p as default
};
